module.exports = __webpack_public_path__ + "img/icon-tw.0ad2edb7.svg";